/**
 * 工具插件共享材质工厂和颜色常量
 * 所有 Overlay 插件通过此模块创建测量/标注用材质
 */
import * as THREE from 'three'

// ─── 颜色常量（参照 dev 分支 MeasureGeometry.ts） ───

/** 测量线段颜色 */
export const TOOL_COLOR_LINE = 0x52a6ff
/** 测量填充面颜色 */
export const TOOL_COLOR_FILL = 0x118af0
/** 测量标签颜色 */
export const TOOL_COLOR_LABEL = '#ffffff'
/** 高度线颜色 */
export const TOOL_COLOR_HEIGHT = 0x118af0
/** 角度弧线颜色 */
export const TOOL_COLOR_ANGLE = 0xffff00
/** 裁切体颜色 */
export const TOOL_COLOR_CLIP = 0xffff00
/** 体积框颜色 */
export const TOOL_COLOR_VOLUME = 0x00ff00
/** 剖面线颜色 */
export const TOOL_COLOR_PROFILE = 0xff0000

// ─── 材质工厂函数（每次调用返回新实例） ───

/**
 * 创建测量线段材质。
 *
 * @param color - 线段颜色
 * @param linewidth - 线宽，默认 2
 * @returns 新的 LineBasicMaterial 实例
 */
export function createLineMaterial(
  color: THREE.ColorRepresentation,
  linewidth = 2
): THREE.LineBasicMaterial {
  return new THREE.LineBasicMaterial({
    color,
    linewidth,
    depthTest: false,
    depthWrite: false,
  })
}

/**
 * 创建虚线材质。
 *
 * @param color - 线段颜色
 * @param dashSize - 实线段长度，默认 5
 * @param gapSize - 间隙长度，默认 3
 * @returns 新的 LineDashedMaterial 实例
 */
export function createDashedMaterial(
  color: THREE.ColorRepresentation,
  dashSize = 5,
  gapSize = 3
): THREE.LineDashedMaterial {
  return new THREE.LineDashedMaterial({
    color,
    dashSize,
    gapSize,
    depthTest: false,
    depthWrite: false,
  })
}

/**
 * 创建半透明填充面材质。
 *
 * @param color - 填充颜色
 * @param opacity - 不透明度，取值 [0, 1]，默认 0.15
 * @returns 新的 MeshBasicMaterial 实例
 */
export function createFillMaterial(
  color: THREE.ColorRepresentation,
  opacity = 0.15
): THREE.MeshBasicMaterial {
  return new THREE.MeshBasicMaterial({
    color,
    opacity,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
    depthWrite: false,
  })
}

/**
 * 创建测量端点材质。
 *
 * @param color - 点颜色
 * @param size - 点大小，单位像素，默认 6
 * @returns 新的 PointsMaterial 实例
 */
export function createPointMaterial(
  color: THREE.ColorRepresentation,
  size = 6
): THREE.PointsMaterial {
  return new THREE.PointsMaterial({
    color,
    size,
    depthTest: false,
    depthWrite: false,
    sizeAttenuation: false,
  })
}
